export enum EPolicyUrls {
  POLICY = 'policy',
  DOC = 'doc',
  GENERAL = 'general',
}
